<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Promociones
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 80px;border-radius:5px')
        v-card(color='', style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text  Administración de Promociones
    v-dialog(v-model='dialog', persistent max-width='700px')
      v-btn.mb-2(v-if='cre' slot='activator', style="border-radius:5px;background-color:#fe0100;") Nueva Promoción
      v-container(style='background-color:white !important;max-width: 700px;')
        v-card-title.justify-center
          span.headline Promoción
        div(style="margin-top: 20px;")
          v-flex(xs12, sm12, md12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12, md8, sm8)
                v-form(enctype="multipart/form-data")

                  v-text-field(outline
                    required
                    v-model="form.titulo"
                    prepend-inner-icon="title"
                    label="Título:"
                    style="margin-bottom:4px;")

                  v-text-field(outline
                    v-model="form.descripcion"
                    prepend-inner-icon="notes"
                    label="Descripción (opcional):"
                    style="margin-bottom:4px;")

                  div(style='display: flex;justify-content: center;margin: 10px;')
                    img(:src='ruta + img' v-if='img && !form.imagen.imageUrl' style='height:200px;width:auto;object-fit:contain;border-radius:8px;')
                    img(:src='form.imagen.imageUrl' v-if='form.imagen.imageUrl' style='height:200px;width:auto;object-fit:contain;border-radius:8px;')

                  v-text-field(outline
                    v-model="form.fechaExpiracion"
                    prepend-inner-icon="event"
                    label="Expira el (YYYY-MM-DDTHH:MM):"
                    type="datetime-local"
                    style="margin-bottom:4px;")
                  div(style='margin-bottom:12px;')
                    span(style='font-size:12px;color:#666;margin-bottom:6px;display:block;') Acceso rápido:
                    div(style='display:flex;flex-wrap:wrap;gap:6px;')
                      v-btn(small @click='setExpiracion(1)' style='background:#222C59;color:white;border-radius:6px;min-width:0;') 24h
                      v-btn(small @click='setExpiracion(2)' style='background:#222C59;color:white;border-radius:6px;min-width:0;') 48h
                      v-btn(small @click='setExpiracion(7)' style='background:#222C59;color:white;border-radius:6px;min-width:0;') 1 semana
                      v-btn(small @click='setExpiracion(15)' style='background:#222C59;color:white;border-radius:6px;min-width:0;') 15 días
                      v-btn(small @click='setExpiracion(30)' style='background:#222C59;color:white;border-radius:6px;min-width:0;') 30 días
                      v-btn(small @click='form.fechaExpiracion = ""' style='background:#9e9e9e;color:white;border-radius:6px;min-width:0;') Sin límite

                  v-text-field(outline label='Seleccione la imagen', @click='pickFile', v-model='form.imagen.imageName', prepend-inner-icon='attach_file')
                  input(
                    type="file"
                    style="display: none;"
                    ref="image"
                    accept="image/*"
                    @change="onFilePicked")

                  div
                    v-flex(v-if="loading === true", xs12 sm12 md12)
                      v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-progress-circular(indeterminate='', color='primary')
                    v-flex(v-if="loading === false", xs12 sm12 md12)
                      v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-btn(style="background:#fe0100;border-radius:10px;", @click.native='save') Guardar
                        v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Promociones
        v-data-table.elevation-1(:headers='headers', :items="resultados", style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td(style="padding:4px;")
              img(:src='ruta + props.item.imagen' v-if='props.item.imagen' style='height:80px;width:80px;object-fit:cover;border-radius:50%;border:3px solid #fe0100;')
              span(v-else) --
            td {{ props.item.titulo }}
            td {{ props.item.descripcion || '--' }}
            td
              span(v-if='!props.item.fechaExpiracion' style='color:#4caf50;font-weight:bold;font-size:12px;') Siempre
              span(v-else-if='estaActiva(props.item.fechaExpiracion)' style='color:#4caf50;font-weight:bold;font-size:12px;') Activa hasta {{ formatFecha(props.item.fechaExpiracion) }}
              span(v-else style='color:#f44336;font-weight:bold;font-size:12px;') Expirada {{ formatFecha(props.item.fechaExpiracion) }}
            td
              v-btn(small, style="background:#222C59;color:white;border-radius:8px;" @click='verVistas(props.item)')
                v-icon(left small) visibility
                | {{ (props.item.vistas || []).length }}
            td
              v-btn.mx-0(v-if='mod' icon, @click='editItem(props.item)')
                v-icon(color='teal') edit
              v-btn.mx-0(v-if='elm' icon, @click='deleteItem(props.item)')
                v-icon(color='pink') delete
    v-dialog(v-model='dialogVistas', max-width='500px')
      v-card
        v-card-title(style='background:#222C59;')
          span(style='color:white;') Vendedores que vieron: {{ promoSeleccionada.titulo }}
        v-card-text(style='padding:16px;')
          div(v-if='!promoSeleccionada.vistas || promoSeleccionada.vistas.length === 0' style='text-align:center;color:grey;padding:20px;') Ningún vendedor ha visto esta promoción aún.
          v-list(v-else dense)
            v-list-tile(v-for='(v, i) in promoSeleccionada.vistas' :key='i')
              v-list-tile-avatar
                v-icon(color='#222C59') person
              v-list-tile-content
                v-list-tile-title {{ v.nombre || v.co_ven }}
                v-list-tile-sub-title Vendedor: {{ v.co_ven }} · {{ formatFecha(v.fecha) }}
        v-card-actions
          v-spacer
          v-btn(flat @click='dialogVistas = false') Cerrar
</template>

<script>
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";
export default {
  name: "mPromociones",
  data: () => ({
    ruta: serverImg,
    loading: false,
    form: {
      titulo: "",
      descripcion: "",
      fechaExpiracion: "",
      imagen: {
        imageName: "",
        imageUrl: "",
        imageFile: ""
      }
    },
    dialog: false,
    editedIndex: -1,
    img: "",
    resultados: [],
    headers: [
      { text: "Imagen", value: "imagen" },
      { text: "Título", value: "titulo" },
      { text: "Descripción", value: "descripcion" },
      { text: "Expira", value: "fechaExpiracion" },
      { text: "Vistas", value: "vistas" },
      { text: "Acciones" }
    ],
    dialogVistas: false,
    promoSeleccionada: {},
    defaultForm: {
      titulo: "",
      descripcion: "",
      fechaExpiracion: "",
      imagen: {
        imageName: "",
        imageUrl: "",
        imageFile: ""
      }
    },
    cre: "",
    mod: "",
    elm: ""
  }),
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    verificacion() {
      for (let i = 0; i < this.$store.state.adminemanuel.permisos.length; i++) {
        if (this.$store.state.adminemanuel.permisos[i].ruta === "Promociones") {
          for (let j = 0; j < this.$store.state.adminemanuel.permisos[i].accion.length; j++) {
            if (this.$store.state.adminemanuel.permisos[i].accion[j] === "Crear") {
              this.cre = "yes";
            }
            if (this.$store.state.adminemanuel.permisos[i].accion[j] === "Modificar") {
              this.mod = "yes";
            }
            if (this.$store.state.adminemanuel.permisos[i].accion[j] === "Eliminar") {
              this.elm = "yes";
            }
          }
        }
      }
    },
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        let peso = false;
        for (let j = 0; j < files.length; j++) {
          if (files[j].size > 4194304) peso = true;
        }
        if (!peso) {
          this.form.imagen.imageName = files[0].name;
          if (this.form.imagen.imageName.lastIndexOf(".") <= 0) return;
          const fr = new FileReader();
          fr.readAsDataURL(files[0]);
          fr.addEventListener("load", () => {
            this.form.imagen.imageUrl = fr.result;
            this.form.imagen.imageFile = files[0];
          });
        } else {
          this.$swal.fire("Oops...", "La imagen debe pesar menos de 4MB.", "error");
        }
      } else {
        this.form.imagen.imageName = "";
        this.form.imagen.imageFile = "";
        this.form.imagen.imageUrl = "";
      }
    },
    initialize() {
      this.img = "";
      this.editedIndex = -1;
      Api.get("promociones").then(res => {
        this.resultados = res.data;
      });
    },
    formatFecha(fecha) {
      if (!fecha) return '';
      return new Date(fecha).toLocaleDateString('es-VE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    },
    estaActiva(fechaExpiracion) {
      if (!fechaExpiracion) return true;
      return new Date(fechaExpiracion) > new Date();
    },
    setExpiracion(dias) {
      const d = new Date();
      d.setDate(d.getDate() + dias);
      const pad = n => String(n).padStart(2, '0');
      this.form.fechaExpiracion = `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    verVistas(item) {
      this.promoSeleccionada = item;
      this.dialogVistas = true;
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.form.imagen = { imageName: "", imageUrl: "", imageFile: "" };
      this.img = "";
      this.dialog = false;
      this.initialize();
    },
    deleteItem(item) {
      this.$swal.fire({
        title: "¿Estás seguro?",
        text: "No podrás revertir esta operación!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Eliminar!"
      }).then(result => {
        if (result.value) {
          Api.delete("promociones/" + item._id)
            .then(() => {
              this.$swal.fire("Felicidades.!", "Eliminación realizada exitosamente.", "success");
              this.initialize();
            })
            .catch(err => console.error(err));
        }
      });
    },
    editItem(item) {
      this.editedIndex = this.resultados.indexOf(item);
      this.form.titulo = item.titulo || "";
      this.form.descripcion = item.descripcion || "";
      this.form._id = item._id;
      if (item.fechaExpiracion) {
        const d = new Date(item.fechaExpiracion);
        const pad = n => String(n).padStart(2, '0');
        this.form.fechaExpiracion = `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
      } else {
        this.form.fechaExpiracion = "";
      }
      if (item.imagen) this.img = item.imagen;
      this.form.imagen = { imageName: "", imageUrl: "", imageFile: "" };
      this.dialog = true;
    },
    save() {
      if (!this.form.titulo) {
        this.$swal.fire("Oops...", "El título es obligatorio.", "error");
        return;
      }
      if (!this.form.imagen.imageFile && !this.img) {
        this.$swal.fire("Oops...", "Debe seleccionar una imagen.", "error");
        return;
      }
      this.loading = true;
      const data = new FormData();
      data.append("titulo", this.form.titulo);
      data.append("descripcion", this.form.descripcion || "");
      data.append("fechaExpiracion", this.form.fechaExpiracion || "");
      if (this.form.imagen.imageFile) {
        data.append("imagen", this.form.imagen.imageFile);
      }
      if (this.editedIndex > -1) {
        data.append("_id", this.form._id);
        Api.put("promociones", data)
          .then(() => {
            this.$swal.fire("Felicidades.!", "Modificación realizada exitosamente.", "success");
            this.loading = false;
            this.close();
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
            this.$swal.fire("Oops...", "Error al modificar. Verifique los datos.", "error");
          });
      } else {
        Api.post("promociones", data)
          .then(() => {
            this.$swal.fire("Felicidades.!", "Registro realizado exitosamente.", "success");
            this.loading = false;
            this.close();
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
            this.$swal.fire("Oops...", "Error al guardar. Verifique los datos.", "error");
          });
      }
    }
  }
};
</script>
<style lang="scss">
</style>
